import classes from './AccountItem.module.scss';
import { Flex, Typography } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Account, AccStatus } from 'entities/account/model/types';
import DualBalance from 'shared/ui/DualBalance/DualBalance';

type Props = {
  account: Account;
  onAccountClick: (accountId: number) => void;
  secured?: boolean;
}

const AccountItem: React.FC<Props> = ({ account, onAccountClick, secured }) => {
  return (
    <div
      className={classes.accountContainer}
      key={account.id}
      onClick={() => onAccountClick(account.id)}
    >
      <Flex gap={4} align='center'>
        <Typography.Text className={classes.title} ellipsis>
          {account.title}
        </Typography.Text>
        {account.status !== AccStatus.Closed ? (
          <div
            style={{
              borderRadius: '50%',
              backgroundColor: 'rgb(185, 227, 181)',
              width: 16,
              height: 16,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <CheckOutlined style={{ fontSize: 8 }} />
          </div>
        ) : (
          <div
            style={{
              borderRadius: '50%',
              backgroundColor: 'rgb(246,176,176)',
              width: 16,
              height: 16,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <CloseOutlined style={{ fontSize: 8 }} />
          </div>
        )}
      </Flex>
      <DualBalance
        ledgerBalance={account.available}
        secured={secured}
        size="md"
        idPrefix={secured ? 'plan-balance-hidden' : 'plan-balance-shown'}
      />
    </div>
  );
};

export default AccountItem;
